<template>
  <section
    id="about"
    class="overflow-hidden"
  >
    <v-row
      class="white"
      no-gutters
    >
      <v-col
        class="pa-5"
        cols="12"
        md="6"
      >
        <base-bubble-1 style="transform: translate(5%, -5%)" />

        <base-heading class="primary--text">
          About Me
        </base-heading>

        <base-text class="mb-5">
          I am Giwantha Sandeepa Wijekoon, 3rd year Information Technology Undergraduate
          at Sri Lanka Institue of Information Technology (SLIIT). Currently I'm learning
          about Javascript related frameworks and new technologies, and I'm Interested in devOps as well.
        </base-text>

        <base-subheading class="primary--text">
          Skills
        </base-subheading>

        <v-alert
          outlined
          color="primary"
        >
          <v-row
            v-for="(skill, i) in skills"
            :key="i"
            style="color: #69A1BB;"
          >
            <v-col
              class="text-uppercase"
              cols="6"
              v-text="skill.name"
            />

            <v-progress-linear
              :value="skill.value"
              color="primary"
              height="8"
            />
          </v-row>
        </v-alert>
      </v-col>

      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/aboutme.jpg')"
          height="100%"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    data: () => ({
      skills: [
        {
          name: 'Problem Solving',
          value: 75,
        },
        {
          name: 'Self Motivation',
          value: 80,
        },
        {
          name: 'Passion for the work',
          value: 85,
        },
      ],
    }),
  }
</script>
